<script lang="ts">
  import { SearchState } from "../../services/search-service";
  import type { SearchStateModel } from "../../models/search.interface";
  import { deleteSearchQueryStringParameter, setQueryStringParameter } from "../../url";
  import TooltipHybridButton from "./TooltipHybridButton.svelte";

  let downloadableSearchInput = false;
  let orderableSearchInput = false;
  let certifiableSearchInput = false;

  SearchState.subscribe((search: SearchStateModel) => {
    downloadableSearchInput = !!search.params.get("downloadable");
    orderableSearchInput = !!search.params.get("orderable");
    certifiableSearchInput = !!search.params.get("certifiable");
  });
</script>

<li class="mb-1">
  <form>
    <fieldset>
      <legend class="mb-2 fs-5">
        Accessibility
        <!-- tooltip icon -->
        <!-- TODO: change this tooltip text to something that makes more sense when coming back to this -->
        <TooltipHybridButton
          searchUrlQueryParam="access-level"
          tooltip='#access-level-tooltip'
        />
        <!--          <button-->
        <!--            type="button"-->
        <!--            id="accessLevelToolTip"-->
        <!--            class="btn btn-link mb-1 ps-1"-->
        <!--            style="color: #1E2125;"-->
        <!--            aria-describedby="accessLevelToolTipContent"-->
        <!--          >-->
        <!--              <i class="bi bi-question-circle-fill" aria-hidden="true"></i>-->
        <!--          </button>-->
        <!--          <Tooltip-->
        <!--            id="accessLevelToolTipContent"-->
        <!--            target={`accessLevelToolTip`}-->
        <!--            placement="right"-->
        <!--            role="tooltip"-->
        <!--          >-->
        <!--            <p>-->
        <!--              This is a list of all observation types available in data access. Some datasets are-->
        <!--              composed of station observations, while others are satellite observations. These are-->
        <!--              referred to as the dataset's <b> Observation Types. </b>-->
        <!--            </p>-->
        <!--          </Tooltip>-->
      </legend>

      <!-- access level list -->
      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          role="checkbox"
          id="al-downloadable-checkbox"
          aria-checked={downloadableSearchInput}
          checked={downloadableSearchInput}
          on:change={() =>
              downloadableSearchInput
                ? deleteSearchQueryStringParameter("downloadable", "true")
                : setQueryStringParameter("downloadable", "true")}
        />
        <label class="form-check-label" for="al-downloadable-checkbox"> Downloadable </label>
      </div>

      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          role="checkbox"
          id="al-orderable-checkbox"
          aria-checked={orderableSearchInput}
          checked={orderableSearchInput}
          on:change={() =>
              orderableSearchInput
                ? deleteSearchQueryStringParameter("orderable", "true")
                : setQueryStringParameter("orderable", "true")}
        />
        <label class="form-check-label" for="al-orderable-checkbox"> Orderable </label>
      </div>

      <div class="form-check">
        <input
          class="form-check-input"
          type="checkbox"
          role="checkbox"
          id="al-certifiable-checkbox"
          aria-checked={certifiableSearchInput}
          checked={certifiableSearchInput}
          on:change={() =>
              certifiableSearchInput
                ? deleteSearchQueryStringParameter("certifiable", "true")
                : setQueryStringParameter("certifiable", "true")}
        />
        <label class="form-check-label" for="al-certifiable-checkbox"> Certifiable </label>
      </div>
    </fieldset>
  </form>


  {#each ["downloadable", "orderable", "certifiable"] as able}
    {#if $SearchState.params.has(able)}
      <div class="d-flex py-1">
        <span
          style="overflow-x: hidden; text-overflow: ellipsis"
          class="badge rounded-pill text-bg-dark pb-0 pe-3 pt-1"
          role="status"
          aria-label="access level search pill: {able}"
        >
          <button
            type="button"
            class="btn p-0 m-0"
            on:click={() => deleteSearchQueryStringParameter(able, "true")}
          >
            <i class="bi bi-x text-bg-dark" aria-label="Delete {able}"></i>
          </button>
          {able}
        </span>
      </div>
    {/if}
  {/each}
</li>
